<template>
  <div>
    <div class="target-header mb-16">
      <div class="target-date">
        <span class="mr-8">{{ $t('config-manager::operate-config::选择年月') }}</span>
        <el-date-picker
          v-model="dt"
          type="month"
          value-format="yyyy-MM"
          :placeholder="$t('config-manager::operate-config::选择年月')"
          @change="getTargetTree"
        ></el-date-picker>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="addTarget()">
        {{ $t('config-manager::operate-config::新增目标') }}
      </el-button>
    </div>
    <z-table
      :columns="columns"
      :data="list"
      :pagination="false"
      row-key="id"
      :tree-props="{ hasChildren: 'hasChildren', children: 'children' }"
    >
      <template #operate="{row}">
        <el-button type="text" @click="addTarget(row.id)" v-if="!row.userId">
          {{ $t('config-manager::operate-config::编辑') }}
        </el-button>
        <el-button type="text" style="color: red" @click="deleteTarget(row.id)" v-if="!row.userId">
          {{ $t('config-manager::operate-config::删除') }}
        </el-button>
      </template>
    </z-table>
    <AddOrUpdate v-model="visible" :editRow="editRow" :date="dt" @success="getTargetTree"></AddOrUpdate>
    <el-dialog :title="$t('config-manager::operate-config::删除确认')" :visible.sync="deleteShow" width="440px">
      <p>{{ $t('config-manager::operate-config::deleteTips') }}</p>
      <div slot="footer">
        <el-button @click="deleteShow = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button type="primary" @click="deleteTeamTarget">{{ $t('config-manager::operate-config::删除') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import AddOrUpdate from './components/addOrUpdate.vue'
import { getTargetTree, deleteTeamTarget } from '@/server/system'
export default {
  components: { AddOrUpdate },
  data() {
    return {
      dt: moment().format('YYYY-MM'),
      visible: false,
      deleteShow: false,
      editRow: {
        type: 'add',
        id: ''
      },
      deleteRow: '',
      list: [],
      columns: [
        { prop: 'name', label: this.$t('config-manager::operate-config::团队'), minWidth: 200 },
        { prop: 'target', label: this.$t('config-manager::operate-config::销售额目标'), width: 150 },
        { prop: 'operate', label: this.$t('config-manager::operate-config::操作'), width: 180 }
      ]
    }
  },
  created() {
    this.getTargetTree()
  },
  methods: {
    async getTargetTree() {
      const { data } = await getTargetTree({
        date: this.dt
      })
      if (data.code === this.$code) {
        console.log('data.data',data.data)
        this.list = (data.data && this.setTreeData(data.data)) || []
      }
    },
    setTreeData(arr) {
      const fn = arr => {
        return arr.map(item => {
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          } else if (item.usersTarget) {
            item.children = fn(
              item.usersTarget.map(i => ({
                ...i,
                id: item.id + i.userId,
                name: i.loginName
              }))
            )
          }
          return item
        })
      }
      return fn(arr)
    },
    addTarget(id) {
      if (id) {
        this.editRow = {
          type: 'edit',
          id: id
        }
      } else {
        this.editRow = {
          type: 'add',
          id: ''
        }
      }
      this.visible = true
    },
    async deleteTarget(id) {
      this.deleteRow = id
      this.deleteShow = true
    },
    async deleteTeamTarget() {
      this.delLoading = true
      const { data } = await deleteTeamTarget({
        id: this.deleteRow,
        date: this.dt
      })
      this.delLoading = false
      if (data.code === this.$code) {
        this.$message.success('删除成功')
        this.deleteRow = ''
        this.getTargetTree()
        this.deleteShow = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.target-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
